export default __webpack_public_path__ + "static/media/Yellow0006.fabff1a0.png";